import { createAction } from '@reduxjs/toolkit'

export const tokenReceived = createAction<any>("tokenReceived");
